import { Component } from '@angular/core';
import { AbstractPageForm } from '../../pages/page-form.abstract';
import { GraphqlService } from 'src/app/graphql/graphql.service';
import { State } from '../../models';
import { FormBuilder, Validators } from '@angular/forms';
import { NewsletterModalComponent } from '../../modals/newsletter-modal/newsletter-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'pk-web-cost-estimator',
    templateUrl: './cost-estimator.component.html',
    styleUrl: './cost-estimator.component.scss',
    standalone: false
})
export class CostEstimatorComponent extends AbstractPageForm {

	public showResults = false;
	public isDeregulated: boolean;
	public states: State[];
	public haveSupplierOptions = [
		{ text: 'Yes', value: 'yes', input: true },
		{ text: 'No', value: 'no', input: false },
		{ text: 'Not Sure', value: 'not-sure', input: false }
	];
	public costEstimatorResults: {
		projectedEstimatedSavings: number;
		projectedAnnualSpend: number;
		saveUpToPercent: number;
	}

	constructor(
		private graphqlService: GraphqlService,
		private fb: FormBuilder,
		private modalService: NgbModal
	) {
		super();
		this.setSubmitText('Calculate', 'Calculating...');
	}

	public override getForm() {
		return this.fb.group({
			state: [null as State, [Validators.required]],
			serviceTypeId: this.CONSTANTS.serviceTypes.electricity.serviceTypeId,
			haveSupplier: this.haveSupplierOptions.find(h => h.value === 'not-sure'),
			monthlySpend: [null as number, [Validators.min(0), Validators.required]]
		});
	}

	public override async loadPageData(): Promise<void> {
		const result = await this.graphqlService.query<{ states: { message: State[] } }>(`
			query GetCostEstimatorData($countryId: Int) {
				states(criteria: { countryId: $countryId }) {
					message {
						stateId
						stateLong
						serviceTypes {
							serviceTypeId
							isDeregulated
						}
					}
				}
			}
		`, {
			countryId: this.CONSTANTS.countries.unitedStates
		});

		this.states = result.data.states.message;
	}

	public chooseState(state: State) {
		this.form.state.setValue(state);
	}

	public override async onFormSubmitted(): Promise<void> {
		this.showResults = true;
		this.costEstimatorResults = null;
		const result = await this.graphqlService.query<{
			costEstimator: {
				projectedEstimatedSavings: number;
				projectedAnnualSpend: number;
				saveUpToPercent: number;
			}
		}>(`
			query GetCostEstimatorResults($criteria: CostEstimatorInput!) {
				costEstimator(criteria: $criteria) {
					projectedEstimatedSavings
					projectedAnnualSpend
					saveUpToPercent
				}
			}
		`, {
			criteria: {
				stateId: this.form.state.value.stateId,
				serviceTypeId: this.form.serviceTypeId.value,
				haveSupplier: this.form.haveSupplier.value.input,
				monthlySpend: this.form.monthlySpend.value,
			}
		});

		this.isDeregulated = !!this.form.state.value.serviceTypes.find(st => st.serviceTypeId)?.isDeregulated;
		this.costEstimatorResults = result.data.costEstimator;
	}

	public openNewsletterModal() {
		this.modalService.open(NewsletterModalComponent);
	}
}
